import {useTexture} from '@react-three/drei'
import {MeshBasicMaterial} from 'three'
import {B1_RETRO_TEXTURE, B1_RETRO_TEXTURE_ONE_EDITION} from '../../utils/static.utils'
export default function ThreeBackPanel({rotation,geometry, position, cardType, cardColor, ...props}){
    const panelImage = cardType.name === "one edition" ? B1_RETRO_TEXTURE_ONE_EDITION : B1_RETRO_TEXTURE
    const texture = useTexture(panelImage)
    const material = new MeshBasicMaterial({
        map:texture,
        transparent: true,
        color: cardColor.contrastHex
    })    
    return <mesh geometry={geometry} material={material}/>
}